import { createStyles, makeStyles, Theme, Typography } from '@material-ui/core';
import EditCommonLabel from './EditCommonLabel';
import EditCommonInfo from './EditCommonInfo';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    elementPreview: { marginTop: theme.spacing(4), width: '70%' }
  })
);

interface EditHeaderProps {
  onUpdateElementLabel: (e: any) => void;
  onUpdateElementInfo: (e: any) => void;
  label: string;
  info: string;
}

const EditHeader = ({
  onUpdateElementLabel,
  onUpdateElementInfo,
  label,
  info
}: EditHeaderProps) => {
  const classes = useStyles();
  return (
    <>
      <EditCommonLabel onChange={onUpdateElementLabel} value={label} />
      <Typography style={{ marginTop: 14 }}>
        <EditCommonInfo onChange={onUpdateElementInfo} value={info} />
      </Typography>
      <Typography
        className={classes.elementPreview}
        variant="h6"
        color="textSecondary"
      >
        Väliotsikko
      </Typography>
    </>
  );
};
export default EditHeader;
